import { updateSettingsContactsApi as generatedUpdateSettingsContactsApi } from '../generated/settingsContacts/updateSettingsContacts';

const updateContactsApi = generatedUpdateSettingsContactsApi.enhanceEndpoints({
  endpoints: {
    updateSettingsContacts: {
      invalidatesTags: ['SettingsContacts'],
    },
  },
});

export const { useUpdateSettingsContactsMutation } = updateContactsApi;
